/* eslint-disable import/no-cycle */
import { takeLatest, put, call } from 'redux-saga/effects';

import {
  LOAD_USER_INFO_FAIL, LOAD_USER_INFO_REQUEST, LOAD_USER_INFO_SUCCESS, loadUserSkills
} from 'src/store/actions/employeesActions';
import { loadUserJobs } from 'src/store/actions/jobActions';
import { selectIsModuleEnabled } from 'src/store/selectors/configurations';
import toastrError from 'src/helpers/toastr/toastrError';

import { wtsApi } from 'src/api';
import store from '../index';

// eslint-disable-next-line func-names
export default function* () {
  yield [
    takeLatest(LOAD_USER_INFO_REQUEST, requestUserInfoSaga)
  ];
}

function* requestUserInfoSaga(userId) {
  try {
    const skillsEnabled = yield call(selectIsModuleEnabled, store.getState(), 'Skills');
    const response = yield call(wtsApi.users.getUserInfoList, { id: userId.userId.id });
    const data = response.data.Data;
    const userJobs = yield call(loadUserJobs, { userIds: userId.userId.id, jobIsDeleted: false });
    const userSkills = skillsEnabled ? yield call(loadUserSkills, { userIds: userId.userId.id }) : {};
    const UserJobs = userJobs.data.Data;
    const UserSkills = skillsEnabled ? userSkills.data.Data : [];

    yield put({
      type: LOAD_USER_INFO_SUCCESS,
      data: {
        ...data,
        UserJobs,
        UserSkills
      }
    });
  } catch (e) {
    yield put({
      type: LOAD_USER_INFO_FAIL,
      err: e.message
    });

    toastrError(e);
  }
}
